import React, { Component } from 'react';
import { Tree, Input, Row, Col, message, Menu } from 'antd';

import { queryMoveOrg, queryOrgEnableTree } from '@api/core/org';

const { TreeNode } = Tree;
const { Search } = Input;

const gData = [];
const dataList = [];

const generateList = data => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i];
    const { uuid } = node;
    dataList.push({ uuid, name: node.name });
    if (node.children) {
      generateList(node.children, node.key);
    }
  }
};

const getParentKey = (key, tree, grandKeys) => {
  let parentKey;
  const grandKey = grandKeys || [];
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some(item => item.uuid === key)) {
        grandKey.push(node.uuid);
        parentKey = grandKey;
      } else if (getParentKey(key, node.children)) {
        grandKey.push(node.uuid);
        parentKey = getParentKey(key, node.children, grandKey);
      }
    }
  }
  return parentKey;
};

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gData,
      searchValue: '',
      expandedKeys: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getOrgEnableTree();
  }

  getOrgEnableTree = () => {
    queryOrgEnableTree().then(res => {
      if (res.statusCode === 200) {
        generateList(res.data);
        this.setState({
          gData: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  moveOrg = params => {
    queryMoveOrg(params).then(res => {
      if (res.statusCode === 200) {
        this.getOrgEnableTree();
      }
    });
  };

  onDragEnter = info => {
    //
    // expandedKeys 需要受控时设置
    // this.setState({
    //   expandedKeys: info.expandedKeys,
    // });
  };

  handleSelect = (a, b, c) => {
    this.props.handleChange(a);
  };

  onDrop = info => {
    const dropKey = info.node.props.eventKey;
    const dragKey = info.dragNode.props.eventKey;
    const dropPos = info.node.props.pos.split('-');
    const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

    const loop = (data, key, callback) => {
      data.forEach((item, index, arr) => {
        if (item.uuid === key) {
          return callback(item, index, arr);
        }
        if (item.children) {
          return loop(item.children, key, callback);
        }
      });
    };
    const { gData: gData1 } = this.state;
    const data = [...gData1];

    // Find dragObject
    let dragObj;
    loop(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1);
      dragObj = item;
    });

    if (!info.dropToGap) {
      // Drop on the content
      loop(data, dropKey, item => {
        item.children = item.children || [];
        // where to insert 示例添加到尾部，可以是随意位置
        item.children.push(dragObj);
      });
    } else if (
      (info.node.props.children || []).length > 0 && // Has children
      info.node.props.expanded && // Is expanded
      dropPosition === 1 // On the bottom gap
    ) {
      loop(data, dropKey, item => {
        item.children = item.children || [];
        // where to insert 示例添加到尾部，可以是随意位置
        item.children.unshift(dragObj);
      });
    } else {
      let ar;
      let i;
      loop(data, dropKey, (item, index, arr) => {
        ar = arr;
        i = index;
      });
      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
    }
    /* this.moveOrg({
				sourceUuid: info.dragNodesKeys[0],
				descUuid: info.node.props.eventKey
			}) */
    this.setState({
      gData: data,
    });
  };

  handleVisible = flag => {};

  handleAdd = () => {
    this.handleVisible(true);
  };

  onChange = e => {
    const { gData: gData1 } = this.state;
    const value = e;
    const parentKeys = dataList
      .map(item => {
        if (item.name.indexOf(value) > -1) {
          const parentKey = getParentKey(item.uuid, gData1);
          return parentKey ? parentKey.join('*') : null;
        }
        return null;
      })
      .filter((item, i, self) => item && self.indexOf(item) === i);
    let arr = [];
    parentKeys.map(item => {
      arr = arr.concat(item.split('*'));
      return item;
    });
    const expandedKeys = arr.filter((item, i, self) => item && self.indexOf(item) === i);
    this.setState({
      searchValue: value,
      expandedKeys,
    });
  };

  onExpand = expandedKeys => {
    this.setState({
      expandedKeys,
    });
  };

  render() {
    const { searchValue, expandedKeys } = this.state;
    const menu = (
      <Menu>
        <Menu.Item>
          <a target="_blank" rel="noopener noreferrer" href="http://www.alipay.com/">
            1st menu item
          </a>
        </Menu.Item>
        <Menu.Item>
          <a target="_blank" rel="noopener noreferrer" href="http://www.taobao.com/">
            2nd menu item
          </a>
        </Menu.Item>
        <Menu.Item>
          <a target="_blank" rel="noopener noreferrer" href="http://www.tmall.com/">
            3rd menu item
          </a>
        </Menu.Item>
      </Menu>
    );
    const loop = data =>
      data.map(item => {
        const index = item.name.indexOf(searchValue);
        const beforeStr = item.name.substr(0, index);
        const afterStr = item.name.substr(index + searchValue.length);
        const title =
          index > -1 ? (
            <span>
              {beforeStr}
              <span style={{ color: '#f50' }}>{searchValue}</span>
              {afterStr}
            </span>
          ) : (
            <span>{item.name}</span>
          );
        if (item.children) {
          return (
            <TreeNode key={item.uuid} title={title}>
              {loop(item.children)}
            </TreeNode>
          );
        }
        return <TreeNode key={item.uuid} title={title} />;
      });
    return (
      <div>
        <Row type="flex" justify="end" style={{ marginBottom: '16px' }}>
          <Col>
            <Search placeholder="输入关键字搜索" onSearch={this.onChange} style={{ width: 200 }} />
          </Col>
        </Row>
        <div className="orgTree">
          <Tree
            defaultExpandAll
            onExpand={this.onExpand}
            className="draggable-tree"
            draggable
            blockNode
            onDragEnter={this.onDragEnter}
            onDrop={this.onDrop}
            showLine
            onSelect={this.handleSelect}
            expandedKeys={expandedKeys}
          >
            {loop(this.state.gData)}
          </Tree>
        </div>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/hr/staff/ComponentOrg.js